export const ACTIONS = {
  RECORD_EVENT_NOTIFICATION: 'RECORD_EVENT_NOTIFICATION',
};

export const recordEventNotification = data => dispatch => {
  dispatch({
    type: ACTIONS.RECORD_EVENT_NOTIFICATION,
    payload: data,
  });
};
